import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Artifact, ArtifactProjectTypeLabel, Version } from "../../models";
import srcSpinner from "../../assets/images/blue-spinner.gif";
import { TableMainContainer } from "../PlaceTable/TableStyle";

import VersionHistoryTable from "./VersionHistoryTable";

const TableContainer = styled(TableMainContainer)`
  height: calc(80vh - 19.8rem);
  max-height: calc(80vh - 22.7rem);
  width: 92%;
  min-width: 100px;
  flex: 1;
`;

const ModalContainer = styled.div`
  box-shadow: 0px 0px 5px 0px gray;
  background-color: #fefefe;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  max-height: 80vh;
  max-width: 80vw;
  width: 80%;
`;

const ModalHeader = styled.div`
  background: #c0c0c0;
  color: var(--primary-fg);
  font-weight: 400;
  font-size: 25px;
  padding: 15px;
  box-sizing: border-box;
  width: 100%;
`;

const ModalButton = styled.button`
  background: rgba(0, 0, 0, 0.78);
  box-shadow: 0px 0.75px 1.5px 0px rgba(0, 0, 0, 0.2);
  color: white;
  font-weight: 100;
  font-size: 12px;
  border-radius: 8px;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  margin-bottom: 20px;
`;

const Heading = styled.div`
  font-size: 25px;
  color: var(--primary-fg);
  padding: 12px 10px;
`;

const SystemName = styled.div`
  font-size: 15px;
  color: var(--primary-fg);
  padding: 0px 10px;
`;

const SubHeader = styled.div`
  font-weight: 600;
  font-size: 15px;
  padding: 22px 30px 20px;
  align-self: flex-start;
`;

const LoaderBase = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;

const TableLoader = styled.img`
  height: 28px;
  width: 28px;
`;

type Props = {
  version: Version[];
  artifact: Artifact;
  onClose?: () => void;
  loading: boolean;
};

const VersionHistory = ({
  artifact,
  onClose,
  version,
  loading,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <ModalContainer data-testid="version-modal">
      <ModalHeader>
        <Heading>{t("modal.version_history.heading")}</Heading>
        <SystemName>
          System:{" "}
          {artifact.artifactProjectType != null
            ? ArtifactProjectTypeLabel[artifact.artifactProjectType]
            : "-"}
        </SystemName>
      </ModalHeader>
      <SubHeader>{t("version.header.active")}</SubHeader>
      <TableContainer>
        <VersionHistoryTable
          artifactId={artifact.id}
          versionList={version.slice(0, 1)}
          label="active"
        />
      </TableContainer>
      <SubHeader>{t("version.header.older")}</SubHeader>
      <TableContainer>
        <VersionHistoryTable
          artifactId={artifact.id}
          versionList={version}
          label="older"
        />
        {loading && (
          <LoaderBase>
            <TableLoader src={srcSpinner} />
          </LoaderBase>
        )}
      </TableContainer>
      <ModalButton
        data-testid="close-modal-root"
        type="button"
        onClick={onClose}
      >
        {t("modal.close")}
      </ModalButton>
    </ModalContainer>
  );
};

export default VersionHistory;
